/* EYF guided cart drawer: free-shipping bar. Loaded as a low-priority module. */

function money(cents, currency) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2) + ' ' + currency;
  }
}

/* Free-shipping bar. The server renders the text for the store currency; other currencies are converted here. */
class EyfShipBar extends HTMLElement {
  static get observedAttributes() { return ['data-subtotal', 'data-currency']; }
  connectedCallback() { this.update(); }
  attributeChangedCallback() { this.update(); }
  update() {
    if (this.dataset.same === 'true') return;
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    const threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
    const subtotal = parseInt(this.dataset.subtotal, 10) || 0;
    const currency = this.dataset.currency || 'USD';
    const text = this.querySelector('.eyf-ship__text');
    const fill = this.querySelector('.eyf-ship__fill');
    const track = this.querySelector('.eyf-ship__track');
    if (!text || !fill || !threshold) return;
    const pct = Math.max(0, Math.min(100, Math.round((subtotal / threshold) * 100)));
    if (subtotal >= threshold) {
      text.innerHTML = 'You’ve unlocked <strong>free shipping</strong>';
    } else {
      text.innerHTML = 'You’re <strong>' + money(threshold - subtotal, currency) + '</strong> away from free shipping';
    }
    fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', String(pct));
  }
}

if (!customElements.get('eyf-ship-bar')) customElements.define('eyf-ship-bar', EyfShipBar);
